var React = require('react');

function Tick (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M13.16 5.83c.22-.23.34-.52.34-.83 0-.3-.12-.6-.34-.83-.45-.45-1.2-.45-1.64 0L6.5 9.5 4.14 7c-.22-.22-.5-.34-.82-.34-.3 0-.6.12-.82.34-.22.22-.34.5-.34.83 0 .3.12.6.34.82l3.18 3.5c.22.23.5.35.82.35.3 0 .6-.12.82-.34l5.84-6.33z"}));
}

Tick.defaultProps = {"width":"50","height":"50","viewBox":"0 0 16 16"};

module.exports = Tick;

Tick.default = Tick;
